import { h } from "preact";
import { useRef } from "preact/hooks";
import { CSSTransition } from "react-transition-group";
import { QuantityMinusRound, QuantityPlusRound } from "../../helpers/icons";

export default function QuantityInputRound({
  quantity,
  setQuantity,
  max = null,
  className = "",
  allowZero = false,
}) {
  const minQuantity = allowZero ? 0 : 1;
  const isZero = quantity <= 0;
  const leftRef = useRef(null);

  return (
    <div className={`${className} quantity-round__wrapper`}>
      <div
        className={`quantity-round${isZero ? " quantity-round--zero" : " quantity-round--nonzero"}`}
      >
        <CSSTransition
          in={!isZero}
          timeout={300}
          unmountOnExit
          classNames="quantity-round__left"
          nodeRef={leftRef}
        >
          <div ref={leftRef} className="quantity-round__left">
            <button
              className="quantity-round__button quantity-round__button--decrease"
              name="minus"
              type="button"
              disabled={quantity <= minQuantity}
              onClick={() => setQuantity(quantity - 1)}
            >
              <span className="visually-hidden">
                {window.localeStrings.product.quantity_decrease}
              </span>
              <QuantityMinusRound />
            </button>
            <label className="quantity-round__input-label">
              <span className="visually-hidden">
                {window.localeStrings.product.quantity}
              </span>
              <input
                className="quantity-round__input"
                type="number"
                name="quantity"
                min={minQuantity}
                max={max}
                step="1"
                value={quantity}
                onChange={(e) => {
                  setQuantity(
                    max !== null
                      ? Math.min(max, parseInt(e.target.value))
                      : parseInt(e.target.value),
                  );
                }}
              />
            </label>
          </div>
        </CSSTransition>
        <button
          className="quantity-round__button quantity-round__button--increase"
          name="plus"
          type="button"
          disabled={max !== null && quantity >= max}
          onClick={() => setQuantity(quantity + 1)}
        >
          <span className="visually-hidden">
            {window.localeStrings.product.quantity_increase}
          </span>
          <QuantityPlusRound />
        </button>
      </div>
    </div>
  );
}
